namespace $.$$ {
	export class $shm_hitalama_map_widget_float_settings_widget_page extends $.$shm_hitalama_map_widget_float_settings_widget_page {
		
		style_display(): string {
			if( this.Map_page().overlayed() ) {
				return this.visible() ? super.style_display() : 'none'
			}

			return super.style_display()
		}

		visible() {
			const id = this.widget_props_id()
			if( id && this.controlled_widget_map_page().selected( new $giper_baza_link(id) ) ) {
				return true
			}
			return false
		}

		controls() {
			if( this.visible() ) {
				return [ this.Page() ]
			}
			this.widget_props_id( null )
			return []
		}

		widget_props_id( next?: string | null ) {
			return this.$.$mol_state_arg.value( 'widget_props', next ) ?? ''
		}

		controlled_widget() {
			const id = this.widget_props_id()!
			return $giper_baza_glob.Pawn( new $giper_baza_link(id), $shm_hitalama_map_widget )
		}
		
		controlled_widget_map_page(): $.$shm_hitalama_map_page {
			const map_id = this.controlled_widget().map().link().str
			return this.$.$shm_hitalama_app.Root(0).Maps().Book( map_id ).Map_page()
		}
		
	}
}
